import equal from 'fast-deep-equal';
import { MonoTypeOperatorFunction } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

export function distinctUntilChangedDeep<T>(): MonoTypeOperatorFunction<T> {
  return distinctUntilChanged((previous: T, current: T) => {
    return equal(previous, current);
  });
}
